<template>
  <QuoteSummaryOrganism
    :title="title"
    :quote="quote"
    :variant="quote.variant"
    :novated="quote.novated"
    :price="quote.price"
    :photo="quote | getQuotePhoto"
    :variant-details="variantDetails"
    :lease-term="quote.leaseTerm / 12"
    :total-costs="totalCosts"
    :frequency="frequency"
    :show-print-action="true"
    :sale-tag-img="saleTagImg"
    @update:frequency="frequency = $event"
  />
</template>

<script>
import isMiles from '@/utils/is-miles';
import { mapState } from 'vuex';
import { getSummaryVariantDetails } from '../../utils/variant';
import getQuotePhoto from '../../filters/get-quote-photo';
import { getAsset } from 'ecx.saigon.ui.common';

export default {
  name: 'QuoteSummaryWidget',
  data() {
    return {
      frequency: this.$Constants.CALCULATION_FREQUENCIES.monthly.value,
      saleTagImg: undefined
    };
  },
  computed: {
    ...mapState({
      quote: (state) => state.quote.quote || {}
    }),
    variantDetails() {
      return getSummaryVariantDetails(this.quote.variant, this.quote);
    },
    totalCosts() {
      let total = 0;
      let novated = this.quote.novated || {};
      let budgets = novated.budgets || [];
      let fees = novated.fees || [];
      budgets.forEach((item) => (total += parseFloat(item.cost)));
      fees.forEach((item) => (total += parseFloat(item.cost)));
      return total;
    },
    title() {
      return [
        this.quote.variant.modelYear,
        ...(isMiles(this.quote)
          ? []
          : [this.quote.make.description, this.quote.model.name]),
        this.quote.variant.name,
      ]
        .filter(Boolean)
        .join(' ');
    }
  },
  async mounted() {
    this.saleTagImg = await getAsset(this.$Constants.SALE_TAG_PATH);
  },
  filters: {
    getQuotePhoto
  },
  components: {
    QuoteSummaryOrganism: () => import('../../components/organism/quote-summary')
  }
};
</script>
